import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { alcoholSupplementalCounselingAddressNameFields } from 'constants/enums/people';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import substanceAlcoholSupplementalCounselingItemValidator from './validators/item';
import { SubstanceAlcoholSupplementalCounselingModel } from './types';

const substanceAlcoholSupplementalCounselingValidator: ValidateJSModel<SubstanceAlcoholSupplementalCounselingModel> = {
  AlcoholTreatmentOrCounselingAnswer: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes, attributeName, options) => {
    if (attributes?.AlcoholTreatmentOrCounselingAnswer && attributes?.AlcoholTreatmentOrCounselingAnswer.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, alcoholSupplementalCounselingAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }
      return {
        presence: true,
        ...additionalValidation,
        accordion: { validator: substanceAlcoholSupplementalCounselingItemValidator },
      };
    }
    return {};
  },
  AlcoholTreatmentOrCounselingComment: {}, // Optional Comment
  AlcoholTreatmentOrCounselingSummaryComment: {} // Optional COmment
};

export default substanceAlcoholSupplementalCounselingValidator;
